import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=f804a210&lang=pug&"
import script from "./Login.vue?vue&type=script&lang=babel&"
export * from "./Login.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Login.vue"
export default component.exports